const useAuth = () => {
  return {
    role: localStorage.getItem('role') || '',
    userId: localStorage.getItem('userId') || '',
    email: localStorage.getItem('email') || '',
    userName: localStorage.getItem('userName') || '',
    isStaff: localStorage.getItem('isStaff') === 'true',
    // authz-v2 TODO: viewAsUser belongs to the deferred ViewAs impersonation flow
    // (needs a backend view-as cookie); false until that ships.
    viewAsUser: false,
  };
};

export default useAuth;
